import "./index.css";

import {
  Button,
  Card,
  Col,
  Grid,
  Menu,
  Popover,
  Progress,
  message,
  theme,
} from "antd";
import {
  CreditCardOutlined,
  DatabaseOutlined,
  MessageOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { getProfileLocal, setProfileLocal } from "../../../utils/common";

import { BiConversation } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegCopy } from "react-icons/fa";
import { ImAttachment } from "react-icons/im";
import { MdOutlineContentPaste } from "react-icons/md";
import { api_url } from "../../../services/api";

const { useToken } = theme;
const { useBreakpoint } = Grid;

export default function CardCourse({ percent, courses }) {
  const [filterIsVisible, setFilterIsVisible] = useState(false);
  const { token } = useToken();
  const screens = useBreakpoint();

  const navigate = useNavigate();
  const [current, setCurrent] = useState("/");

  const onClickMenu = (item) => {
    const clicked = menuItem.find((_item) => _item.key === item.key);
    navigate(clicked.key);
    setCurrent("");
  };

  const menuItem = [
    {
      label: "Conteúdo",
      key: "/mycourses/content",
      icon: <FaRegCopy />,
    },
    {
      label: "Fórum",
      key: "/mycourses/forum",
      icon: <BiConversation />,
    },
    {
      label: "Material",
      icon: <ImAttachment />,
      key: "/mycourses/material",
    },
    {
      label: "Avaliação",
      key: "/mycourses/evaluation",
      icon: <MdOutlineContentPaste />,
    },
  ];


  return (
    <Col
      span={24}
      sm={24}
      md={24}
      lg={8}
      
      style={{
        maxWidth: "320px",
        padding: !screens?.md ? '0px' : '10px',
        width: "100%",
        margin: !screens?.md ? '0 auto' : '',
      }}
    >
      <Card
        className="card"
        cover={
          <div
            className="cover"
            style={{
              width: "100%",
              backgroundColor: "#F5DB33",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {percent === 100 && (
              <img
                alt={'Imagem de conclusão do curso'}
                src={'/imgs/finish.svg'}
                style={{
                  objectFit: "contain",
                  position: "absolute",
                  top: '62px',
                  left: '38%',
                  zIndex: 1,
                }}
              />
            )}
            <img
              className={percent === 100 ? "completed-course" : ""}
              alt={'Imagem do curso'}
              src={`${api_url}/upload/${courses.course_thumbnail}`

              }

              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}

            />
          </div>
        }
      >
        {/* <Popover

          className="popover"
          placement="bottomLeft"
          trigger="click"
          content={
            <Menu
              onClick={onClickMenu}
              items={menuItem}
              className="menu-popover"
            />
          }
          open={filterIsVisible}
          onOpenChange={setFilterIsVisible}
        >
          {percent !== 100 && (
            <Button
              icon={<BsThreeDotsVertical size={20} />}
              size="middle"
              style={{
                backgroundColor: "rgba(142, 142, 142, 0.65)",
                color: "#FFF",
                border: "none",
                borderRadius: "3px",
              }}
            />
          )}

        </Popover> */}
        <div className="flex">
          <div className="card-body">
            <span style={{ padding: "10px" }}>{courses?.course_name || "Nome do curso"}</span>
            <div className="percent">
              <span className="text-percent">{courses?.course_period || 'Periodo do curso'}</span>
              <span className="text-percent">{percent.toFixed(2)}%</span>
            </div>
            <Progress
              percent={percent}
              strokeColor={token.colorFillSecondary}
              trailColor="#DDDDDD"
            />
            <div className="flex-button">
              {percent === 100 ? (
                <>
                  <Button
                    style={{
                      backgroundColor: '#E5E5E5',
                      color: '#000000',
                      width: '100%',
                      textAlign: 'center',
                      border: 'none',
                      cursor: 'unset'
                    }}
                    disabled
                  >
                    Curso Concluído
                  </Button>
                </>
              ) : (
                <>
                  <Link to={`/mycourses/${courses.course_hash}`}>
                    <Button
                      type="link" className="more-button"
                      style={{
                        width: '100%',
                      }}
                      onClick={() => {
                        setProfileLocal({ ...getProfileLocal(), enrollment_hash: courses.enrollment_hash })
                      }}
                    >
                      Saiba mais
                    </Button>
                  </Link>
                  <Link to={`/mycourses/${courses.course_hash}`}>
                    <Button
                      type="link"
                      className="continue-button"
                      style={{
                        backgroundColor: token.colorFillSecondary,
                        width: '100%',
                      }}
                      onClick={() => {
                        setProfileLocal({ ...getProfileLocal(), enrollment_hash: courses.enrollment_hash })
                      }}
                    >
                      Continuar
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div >
      </Card >

    </Col >
  );
}
